import React from 'react';

import SidebarMenu, { type SidebarMenuItem } from './sidebar-menu';

const items: SidebarMenuItem[] = [
  { key: 'countries', to: '/settings/countries', label: 'Countries' },
  {
    key: 'country-languages',
    to: '/settings/country-languages',
    label: 'Country Languages',
  },
  { key: 'tags', to: '/settings/tags', label: 'Tags' },
  {
    key: 'holiday-periods',
    to: '/settings/holiday-periods',
    label: 'Holiday Periods',
  },
];

function SidebarSettings(): React.ReactElement {
  return <SidebarMenu items={items} />;
}

export default SidebarSettings;
